import React from "react";
import StaffListLayer from "../components/StaffListLayer";
import Breadcrumb from "../components/Breadcrumb";

const StaffListPage = () => {

  return (
  
  <>
  <Breadcrumb title={"Staff List"}/>
  
  <StaffListLayer />
  </>
);
};

export default StaffListPage;
